"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const EBecropController_1 = __importDefault(require("../Types/EBecropController"));
const MapBmkController_1 = __importDefault(require("@becrop/components/MapBmk/MapBmkController"));
let FiltersPanel = class FiltersPanel extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.stateNameSelected = this.eBecropController.filteredState.state;
        this.cropNameSelected = this.eBecropController.filteredState.crop.name
            ? this.eBecropController.filteredState.crop.name
            : this.eBecropController.statesCrops[0];
        this.metricNameSelected = this.eBecropController.filteredState.metric
            ? this.eBecropController.filteredState.metric
            : this.eBecropController.statesMetrics[0];
        this.statesFilter = this.eBecropController.statesNames.slice(0, 4);
        this.cropsFilter = this.eBecropController.statesCrops.slice(0, 4);
        this.metricsFilter = this.eBecropController.statesMetrics.slice(0, 4);
    }
    get loadingZone() {
        return this.mapBmkController.mapLoading;
    }
    get disabledApplyFilters() {
        if (this.stateNameSelected.length > 0 &&
            this.cropNameSelected.length > 0 &&
            this.metricNameSelected.length > 0)
            return false;
        return true;
    }
    applyFilters() {
        this.eBecropController.updateResolution('hight');
        this.eBecropController.findState(this.stateNameSelected, this.cropNameSelected, this.metricNameSelected);
        this.statesFilter = this.eBecropController.statesNames
            .sort(this.orderTabsState)
            .slice(0, 4);
        this.cropsFilter = this.eBecropController.statesCrops
            .sort(this.orderTabsCrop)
            .slice(0, 4);
        this.metricsFilter = this.eBecropController.statesMetrics
            .sort(this.orderTabsMetric)
            .slice(0, 4);
    }
    updateSelectState(stateName, isTab = false) {
        this.stateNameSelected = stateName;
        if (!isTab) {
            this.statesFilter = this.eBecropController.statesNames
                .sort(this.orderTabsState)
                .slice(0, 4);
        }
    }
    updateSelectCrop(cropName, isTab = false) {
        this.cropNameSelected = cropName;
        if (!isTab) {
            this.cropsFilter = this.eBecropController.statesCrops
                .sort(this.orderTabsCrop)
                .slice(0, 4);
        }
    }
    updateSelectMetric(metricName, isTab = false) {
        this.metricNameSelected = metricName;
        if (!isTab) {
            this.metricsFilter = this.eBecropController.statesMetrics
                .sort(this.orderTabsMetric)
                .slice(0, 4);
        }
    }
    orderTabsCrop(a, b) {
        if (a === this.cropNameSelected) {
            return -1; // Si el nombre del cultivo es igual al nombre filtrado, colocarlo primero
        }
        if (b === this.cropNameSelected) {
            return 1; // Si el nombre del cultivo es igual al nombre filtrado, colocarlo primero
        }
        // Ordenar los otros elementos alfabéticamente
        return a.localeCompare(b);
    }
    orderTabsState(a, b) {
        if (a === this.stateNameSelected) {
            return -1; // Si el nombre del cultivo es igual al nombre filtrado, colocarlo primero
        }
        if (b === this.stateNameSelected) {
            return 1; // Si el nombre del cultivo es igual al nombre filtrado, colocarlo primero
        }
        // Ordenar los otros elementos alfabéticamente
        return a.localeCompare(b);
    }
    orderTabsMetric(a, b) {
        if (a === this.metricNameSelected) {
            return -1; // Si el nombre del cultivo es igual al nombre filtrado, colocarlo primero
        }
        if (b === this.metricNameSelected) {
            return 1; // Si el nombre del cultivo es igual al nombre filtrado, colocarlo primero
        }
        // Ordenar los otros elementos alfabéticamente
        return a.localeCompare(b);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new EBecropController_1.default() })
], FiltersPanel.prototype, "eBecropController", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new MapBmkController_1.default() })
], FiltersPanel.prototype, "mapBmkController", void 0);
FiltersPanel = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            SelectField: bmk_ui_framework_1.SelectField,
            Select: bmk_ui_framework_1.Select,
            Tag: bmk_ui_framework_1.Tag,
            PencilIcon: bmk_ui_framework_1.PencilIcon,
        },
    })
], FiltersPanel);
exports.default = FiltersPanel;
